import { gtmEventPush, segmentEventPush } from '../modules/ga/GTMdatalayer';
import { signInCheck } from '../components/common/CheckUserStatus';

export const cancelReturnClickGA = (orderId, orderStatus) => {
  gtmEventPush({
    event: 'order_item_details_interaction',
    event_category: 'order item details interaction',
    event_action: 'cancel return',
    order_id: orderId,
    order_status: String(orderStatus).toUpperCase(),
    page_name: 'order item details screen',
    page_type: 'order item details screen'
  });
};

export const confirmCancellationClickGA = (orderId, orderStatus) => {
  gtmEventPush({
    event: 'return cancellation halfcard interaction',
    event_category: 'return cancellation halfcard screen interactions',
    event_action: 'confirm cancellation',
    order_id: orderId,
    order_status: String(orderStatus).toUpperCase(),
    page_name: 'return cancellation halfcard screen',
    page_type: 'return cancellation halfcard screen'
  });
};

export const returnCancelRequestedPageLoadGA = () => {
  gtmEventPush({
    event: 'pageload',
    page_name: 'return cancellation halfcard screen',
    page_type: 'return cancellation halfcard screen'
  });
};

export const returnCancelFailedGA = (orderId, orderStatus) => {
  gtmEventPush({
    event: 'order_item_details_interaction',
    event_category: 'order item details interaction',
    event_action: 'retrun cancel failure',
    order_id: orderId,
    order_status: String(orderStatus).toUpperCase(),
    page_name: 'order item details screen',
    page_type: 'order item details screen'
  });
};

export const returnCancelReqInProgressGA = (orderId, orderStatus) => {
  gtmEventPush({
    event: 'order_item_details_interaction',
    event_category: 'order item details interaction',
    event_action: 'return cancellation message',
    event_label: 'seen',
    order_id: orderId,
    order_status: String(orderStatus).toUpperCase(),
    page_name: 'order item details screen',
    page_type: 'order item details screen'
  });
};

export const recentIssueViewMoreClickGA = () => {
  gtmEventPush({
    event: 'buttonTap',
    event_category: 'buttonTap',
    event_action: 'Selfcare - Clicked on view more complaints',
    event_label: 'Complaintcard Clicked Viewmore',
    page_name: 'self care/ self care screen',
    page_type: 'self care/ self care screen'
  });

  // Segment Push event
  segmentEventPush({
    event: 'View More Complaint Clicked',
    event_category: 'buttonTap',
    event_action: 'Selfcare - Clicked on view more complaints',
    event_label: 'Complaintcard Clicked Viewmore',
    screen_name: 'self care/ self care screen',
    // page_type: 'self care/ self care screen'
  });
 
};

export const viewOrderClickGA = (complaingId, orderId, status, resolutionBy) => {
  gtmEventPush({
    event: 'buttonTap',
    event_category: 'buttonTap',
    event_action: 'Selfcare - Clicked on view order on complaint card',
    event_label: `Complaintcard_Clicked_${complaingId}_${orderId}_${status}_${resolutionBy}`,
    page_name: 'self care/ Complaint Card List/customer support screen',
    page_type: 'self care/ Complaint Card List/customer support screen'
  });

  // Segment Push Event
  segmentEventPush({
    event: 'View Order Clicked',
    event_category: 'buttonTap',
    event_action: 'Selfcare - Clicked on view order on complaint card',
    event_label: `Complaintcard_Clicked_${complaingId}_${orderId}_${status}_${resolutionBy}`,
    screen_name: 'self care/ Complaint Card List/customer support screen',
    page_type: 'self care/ Complaint Card List/customer support screen'
  });
};

export const complaintCardClickGA = (complaingId, orderId, status, resolutionBy) => {
  gtmEventPush({
    event: 'buttonTap',
    event_category: 'buttonTap',
    event_action: 'Selfcare - Clicked on complaint card for details',
    event_label: `Complaintcard_Clicked_${complaingId}_${orderId}_${status}_${resolutionBy}`,
    page_name: 'self care/ Complaint Card List/customer support screen',
    page_type: 'self care/ Complaint Card List/customer support screen'
  });
  //Complaint Card Clicked
  segmentEventPush({
    event: 'Complaint Card Clicked'
  })
  
};

export const complaintImageUploadStatusGA = (
  uploadSuccess,
  complaingId,
  orderId,
  incidentStatus,
  resolutionBy
) => {
  gtmEventPush({
    event: 'complaint_card_screen_interactions',
    event_category: 'complaint card screen interactions',
    event_action: uploadSuccess ? 'image upload success' : 'image upload failure',
    event_label: `Complaintcard_Clicked_${complaingId}_${orderId}_${incidentStatus}_${resolutionBy}`,
    page_name: 'complaint card screen',
    page_type: 'complaint card screen'
  });
};

export const complaintSubmitClickGA = (complaingId, orderId, incidentStatus, resolutionBy) => {
  gtmEventPush({
    event: 'complaint_card_screen_interactions',
    event_category: 'complaint card screen interactions',
    event_action: 'submit',
    event_label: `Complaintcard_Clicked_${complaingId}_${orderId}_${incidentStatus}_${resolutionBy}`,
    page_name: 'complaint card screen',
    page_type: 'complaint card screen'
  });
};

export const complaintSubmittedGA = (complaingId, orderId, incidentStatus, resolutionBy) => {
  gtmEventPush({
    event: 'complaint_card_screen_interactions',
    event_category: 'complaint card screen interactions',
    event_action: 'details submitted',
    event_label: `Complaintcard_Clicked_${complaingId}_${orderId}_${incidentStatus}_${resolutionBy}`,
    page_name: 'complaint card screen',
    page_type: 'complaint card screen'
  });
};

export const complaintEnterMoreClickGA = (complaingId, orderId, incidentStatus, resolutionBy) => {
  gtmEventPush({
    event: 'complaint_card_screen_interactions',
    event_category: 'complaint card screen interactions',
    event_action: 'enter more details',
    event_label: `Complaintcard_Clicked_${complaingId}_${orderId}_${incidentStatus}_${resolutionBy}`,
    page_name: 'complaint card screen',
    page_type: 'complaint card screen'
  });
};

export const noReturnExchangeCouponGA = (couponName, orderId, productId, orderStatus) => {
  gtmEventPush({
    event: 'order_item_details_interaction',
    event_category: 'order item details interaction',
    event_action: 'no return exchange coupon',
    event_label: couponName,
    order_id: orderId,
    product_id: productId,
    order_status: String(orderStatus).toUpperCase(),
    page_name: 'order item details screen',
    page_type: 'order item details screen'
  });
};

export const returnReasonSelectionMsgGA = (orderId, orderStatus) => {
  gtmEventPush({
    event: 'order_item_details_interaction',
    event_category: 'order item details interaction',
    event_action: 'appropriate reason selection message',
    event_label: 'seen',
    order_id: orderId,
    order_status: String(orderStatus).toUpperCase(),
    page_name: 'order item details screen',
    page_type: 'order item details screen'
  });
};

export const getReturnWindowTextForGA = (returnCodCommunication = {}, orderEntry = {}) => {
  const { isExchangeable, isReturnable, returnWindow = 0 } = orderEntry;
  const {
    messageReturnDesktop = '',
    messageExchangeDesktop = '',
    messageReturnAndExchangeDesktop = '',
    messageNoReturnAndExchangeDesktop = ''
  } = returnCodCommunication;
  const messageReturn = messageReturnDesktop?.replace('%x', returnWindow);
  const messageExchange = messageExchangeDesktop?.replace('%x', returnWindow);
  const messageReturnAndExchange = messageReturnAndExchangeDesktop?.replace('%x', returnWindow);

  let returnExchangeMessage = '';
  if (isReturnable && isExchangeable && returnWindow > 0) {
    returnExchangeMessage = messageReturnAndExchange;
  } else if (isReturnable && !isExchangeable && returnWindow > 0) {
    returnExchangeMessage = messageReturn;
  } else if (!isReturnable && isExchangeable && returnWindow > 0) {
    returnExchangeMessage = messageExchange;
  } else {
    returnExchangeMessage = messageNoReturnAndExchangeDesktop;
  }
  return returnExchangeMessage;
};

export const getRefundSummary = (
  canceledRefundDetails,
  entryCode,
  productName,
  exisitingProductData
) => {
  let totalAmountPaid = 0;
  let bankDiscountDeducted = 0;
  let totalQty = 0;
  let isClawBackApplied = false;

  canceledRefundDetails?.data?.refundsDetail?.forEach(refund => {
    refund.itemsList.forEach(item => {
      if (item.itemId === entryCode) {
        const amountPaid = item.unitCost * item.qty;
        totalAmountPaid += amountPaid;
        totalQty += item.qty;

        // check refundActivities for BANK_OFFER
        refund?.refundActivities?.forEach(activity => {
          if (activity?.itemId === entryCode && activity?.mop === 'BANK_OFFER') {
            bankDiscountDeducted += activity?.amount;
          }
        });

        if (refund.isClawBackApplied) {
          isClawBackApplied = isClawBackApplied || refund.isClawBackApplied;
        }
      }
    });
  });

  const totalRefund = totalAmountPaid - bankDiscountDeducted;
  const averageUnitCost = totalQty > 0 ? totalAmountPaid / totalQty : 0;

  return {
    productName: productName,
    totalAmountPaid,
    totalRefund,
    bankDiscountDeducted,
    totalQty,
    unitCost: averageUnitCost, // combined unit cost
    existingBankDiscountData: {
      isClawBackApplied,
      ...(exisitingProductData || {})
    }
  };
};

export const getRefundSummaryForCancelRefundImprovement = (
  canceledRefundDetails,
  entryCode,
  productName,
  exisitingProductData
) => {
  let totalAmountPaid = 0;
  let bankDiscountDeducted = 0;
  let totalQty = 0;
  let isClawBackApplied = false;
  let totalConvenienceFee = 0;
  const convenienceFeeData = {
    DELIVERY_FEE: 0,
    PRIORITY_DELIVERY_FEE: 0,
    COD_FEE: 0,
    RVP_FEE: 0
  };

  canceledRefundDetails?.data?.refundsDetail?.forEach(refund => {
    refund.itemsList.forEach(item => {
      if (item.itemId === entryCode) {
        const amountPaid = item.unitCost * item.qty;
        totalAmountPaid += amountPaid;
        totalQty += item.qty;

        // check refundActivities for BANK_OFFER
        refund?.refundActivities?.forEach(activity => {
          if (activity?.itemId === entryCode && activity?.mop === 'BANK_OFFER') {
            bankDiscountDeducted += activity?.amount;
          }
        });

        if (refund.isClawBackApplied) {
          isClawBackApplied = isClawBackApplied || refund.isClawBackApplied;
        }

        // check refundActivities for NON_REFUNDABLE_AMOUNT
        item?.refundableAmountBreakup?.forEach(activity => {
          if (activity?.chargeType === 'RVP_RETURN_FEE') return;

          convenienceFeeData[activity?.chargeType] += activity?.amount;
          totalConvenienceFee += activity?.amount;
        });

        item?.nonRefundableAmountBreakup?.forEach(activity => {
          if (activity?.chargeType === 'RVP_RETURN_FEE') return;

          convenienceFeeData[activity?.chargeType] += activity?.amount;
          totalConvenienceFee += activity?.amount;
        });
      }
    });
  });

  const totalRefund = totalAmountPaid - bankDiscountDeducted;
  const averageUnitCost = totalQty > 0 ? totalAmountPaid / totalQty : 0;

  return {
    productName: productName,
    totalAmountPaid,
    totalRefund,
    bankDiscountDeducted,
    totalQty,
    unitCost: averageUnitCost, // combined unit cost
    totalConvenienceFee,
    convenienceFeeData,
    existingBankDiscountData: {
      isClawBackApplied,
      ...(exisitingProductData || {})
    }
  };
};